import {
  REGISTER_USER_REQUEST,
  REGISTER_USER_FAILURE,
  REGISTER_USER_SUCCESS,
  GET_LICENSE_REQUEST,
  GET_LICENSE_SUCCESS,
  GET_LICENSE_FAILURE,
  CLEAR_INVITEE_LICENSES,
  VERIFY_EMAIL_UNIQUE_REQUEST,
  VERIFY_EMAIL_UNIQUE_SUCCESS,
  VERIFY_EMAIL_UNQIUE_FAILURE,
  VERIFY_USERNAME_UNIQUE_REQUEST,
  VERIFY_USERNAME_UNIQUE_SUCCESS,
  VERIFY_USERNAME_UNQIUE_FAILURE,
} from '@constants/actionTypes'

const initialState = {
  isFetching: false,
  license: null,
  licenses: [],
  isVerifyingEmail: false,
  errorMessage: '',
  isVerifyingUsername: false,
  status: null,
}

const reducer = function(state = initialState, action) {
  switch (action.type) {
    case REGISTER_USER_REQUEST:
      return {
        ...state,
        isFetching: true,
        newUser: action.args,
        errorMessage: '',
        status: action.status,
      }
    case REGISTER_USER_FAILURE:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.message,
        status: action.status,
      }
    case REGISTER_USER_SUCCESS:
      return {
        ...state,
        isFetching: false,
        message: action.message,
        status: action.status,
      }
    case GET_LICENSE_REQUEST:
      return {
        ...state,
        isGetting: action.isGetting,
        errorMessage: '',
      }
    case GET_LICENSE_SUCCESS:
      const newState = {
        ...state,
        isGetting: action.isGetting,
        license: action.license,
        licenses: action.licenses,
      }
      return newState
    case GET_LICENSE_FAILURE:
      return {
        ...state,
        isGetting: action.isGetting,
        errorMessage: action.message,
        license: null,
      }
    case CLEAR_INVITEE_LICENSES:
      return {
        ...state,
        inviteeLicenses: action.inviteeLicenses,
      }
    case VERIFY_EMAIL_UNIQUE_REQUEST:
      return {
        ...state,
        isVerifyingEmail: action.isVerifyingEmail,
        errorMessage: '',
      }
    case VERIFY_EMAIL_UNIQUE_SUCCESS:
      return {
        ...state,
        isVerifyingEmail: action.isVerifyingEmail,
        errorMessage: '',
      }
    case VERIFY_EMAIL_UNQIUE_FAILURE:
      return {
        ...state,
        isVerifyingEmail: action.isVerifyingEmail,
        errorMessage: action.message,
      }
    case VERIFY_USERNAME_UNIQUE_REQUEST:
      return {
        ...state,
        isVerifyingUsername: action.isVerifyingUsername,
        errorMessage: '',
      }
    case VERIFY_USERNAME_UNIQUE_SUCCESS:
      return {
        ...state,
        isVerifyingUsername: action.isVerifyingUsername,
        errorMessage: '',
      }
    case VERIFY_USERNAME_UNQIUE_FAILURE:
      return {
        ...state,
        isVerifyingUsername: action.isVerifyingUsername,
        errorMessage: action.message,
      }

    default:
      return state
  }
}

export default reducer
